import { confirmed, double, email, max_value, min_value, required } from "vee-validate/dist/rules"
import { extend, setInteractionMode } from "vee-validate"

import { i18n } from "./i18n"
import moment from "moment"

setInteractionMode("eager")

extend("required", {
  ...required,
  message: i18n.t("this_field_is_required"),
})

extend("year", value => {
  let valid = value  && value.match(/^[0-9]{4}$/) && value > 1900
  if (valid != null && valid != false) {
    return true
  }
  return i18n.t("must_be_a_year")
})

extend("email", {
  ...email,
  message: i18n.t("this_field_must_be_a_valid_email"),
})

extend("confirmed", {
  ...confirmed,
  message: i18n.t("this_fields_confirmation_does_not_match"),
})

extend("duration", value => {
  let valid = value && value.match(/^\d{2}:\d{2}$/)
  if (valid != null && valid != false) {
    return true
  }
  return i18n.t("must_be_duration")
})

extend("isrc", value => {
  let valid = value && value.match(/^[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}$/)
  if (valid != null && valid != false) {
    return true
  }
  return i18n.t("must_be_isrc")
})

extend("after", {
  params: ["target", "format", "interval", "units", "displayFormat"],
  validate (value, { target, format, interval, units }) {
    if (value && target) {
      return moment(value, format).add(1, "day").subtract(interval || 2, units || "day") >= moment(target, format)
    } else {
      return true
    }
  },
  message: (fieldName, placeholders) => {
    let target_date = moment(placeholders._target_ || placeholders.target, placeholders.format)
    target_date = target_date.add(placeholders.interval || 2, placeholders.units || "day").subtract(2, "day")
    placeholders._target_ = target_date.format(placeholders.displayFormat || placeholders.format)
    return i18n.t("must_be_before_target", placeholders)
  }
})

extend("double", {
  ...double,
  message: i18n.t("must_be_a_decimal")
})

extend("positive", {
  validate (value) {
    return value > 0
  },
  message: i18n.t("must_be_positive")
})

extend("max_decimals_8", {
  validate (value) {
    const [, fraction] = String(value).split(".")
    return !fraction || fraction.length <= 8
  },
  message: () => i18n.t("must_have_at_most_8_decimal_places")
})

extend("max_value", {
  ...max_value,
  message: i18n.t("must_be_less_than")
})

extend("min_value", {
  ...min_value,
  message: i18n.t("must_be_more_than")
})
